export default "__VITE_ASSET__CkyS_prF__"